export { default as ClassicPostings } from './ClassicPostings';
export { default as useClassicPostings } from './useClassicPostings';
export { default as useCanSeeClassicPostings } from './useCanSeeClassicPostings';

/** The reporting leaf's `metric` value: `/campaigns/:id/reporting?state=~(metric~'classicPostings)`. */
export const CLASSIC_POSTINGS_METRIC = 'classicPostings';
